import React from 'react';
import { AdminLayout } from '../../components/layout/AdminLayout';
import { useTenant } from '../../lib/tenant-context';
import { useLoyaltyDashboard } from '../../lib/loyalty-hooks';
import { Card } from '../../components/ui/Card';
import { Users, Star, Gift, Trophy } from 'lucide-react';
import { formatCurrency } from '../../lib/utils';
export function LoyaltyDashboardPage() {
  const {
    restaurant,
    role,
    signOut
  } = useTenant();
  const {
    customers,
    loading
  } = useLoyaltyDashboard(restaurant.restaurant_id);
  const totalCustomers = customers.length;
  const totalPoints = customers.reduce((sum, c) => sum + (c.current_points || 0), 0);
  const totalRewardsAvailable = customers.reduce((sum, c) => sum + (c.available_rewards_count || 0), 0);
  const totalRewardsRedeemed = customers.reduce((sum, c) => sum + (c.redeemed_rewards_count || 0), 0);
  return <AdminLayout restaurant={restaurant} role={role} onSignOut={signOut} data-id="element-2766">
      <div className="p-6 max-w-7xl mx-auto space-y-6" data-id="element-2767">
        <div data-id="element-2768">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-2769">
            Programa de Lealtad
          </h1>
          <p className="text-gray-500" data-id="element-2770">
            Gestiona tus clientes frecuentes y beneficios
          </p>
        </div>

        {/* KPIs */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-2771">
          <Card className="p-6" data-id="element-2772">
            <div className="flex items-center gap-4" data-id="element-2773">
              <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-2774">
                <Users className="w-6 h-6 text-blue-600" data-id="element-2775" />
              </div>
              <div data-id="element-2776">
                <p className="text-sm text-gray-500 font-medium" data-id="element-2777">
                  Clientes Leales
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-2778">
                  {totalCustomers}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-2779">
            <div className="flex items-center gap-4" data-id="element-2780">
              <div className="w-12 h-12 bg-yellow-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-2781">
                <Star className="w-6 h-6 text-yellow-600" data-id="element-2782" />
              </div>
              <div data-id="element-2783">
                <p className="text-sm text-gray-500 font-medium" data-id="element-2784">
                  Puntos Emitidos
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-2785">
                  {totalPoints}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-2786">
            <div className="flex items-center gap-4" data-id="element-2787">
              <div className="w-12 h-12 bg-green-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-2788">
                <Gift className="w-6 h-6 text-green-600" data-id="element-2789" />
              </div>
              <div data-id="element-2790">
                <p className="text-sm text-gray-500 font-medium" data-id="element-2791">
                  Beneficios Disponibles
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-2792">
                  {totalRewardsAvailable}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-2793">
            <div className="flex items-center gap-4" data-id="element-2794">
              <div className="w-12 h-12 bg-purple-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-2795">
                <Trophy className="w-6 h-6 text-purple-600" data-id="element-2796" />
              </div>
              <div data-id="element-2797">
                <p className="text-sm text-gray-500 font-medium" data-id="element-2798">
                  Beneficios Redimidos
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-2799">
                  {totalRewardsRedeemed}
                </p>
              </div>
            </div>
          </Card>
        </div>

        {/* Customer Table */}
        <Card className="overflow-hidden" data-id="element-2800">
          <div className="p-6 border-b border-gray-200" data-id="element-2801">
            <h2 className="font-bold text-gray-900" data-id="element-2802">Directorio de Clientes</h2>
          </div>
          <div className="overflow-x-auto" data-id="element-2803">
            <table className="w-full text-left text-sm" data-id="element-2804">
              <thead className="bg-gray-50 text-gray-500" data-id="element-2805">
                <tr data-id="element-2806">
                  <th className="px-6 py-4 font-medium" data-id="element-2807">Cliente</th>
                  <th className="px-6 py-4 font-medium" data-id="element-2808">Teléfono</th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-2809">Visitas</th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-2810">
                    Total Gastado
                  </th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-2811">
                    Ticket Promedio
                  </th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-2812">Puntos</th>
                  <th className="px-6 py-4 font-medium" data-id="element-2813">Nivel</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" data-id="element-2814">
                {loading ? <tr data-id="element-2815">
                    <td colSpan={7} className="px-6 py-8 text-center text-gray-500" data-id="element-2816">
                      Cargando clientes...
                    </td>
                  </tr> : customers.length === 0 ? <tr data-id="element-2817">
                    <td colSpan={7} className="px-6 py-8 text-center text-gray-500" data-id="element-2818">
                      No hay clientes registrados aún.
                    </td>
                  </tr> : customers.map(customer => <tr key={customer.customer_id} className="hover:bg-gray-50" data-id="element-2819">
                      <td className="px-6 py-4 font-medium text-gray-900" data-id="element-2820">
                        {customer.name || 'Sin nombre'}
                      </td>
                      <td className="px-6 py-4 text-gray-500" data-id="element-2821">
                        {customer.phone}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-900" data-id="element-2822">
                        {customer.total_orders}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-900" data-id="element-2823">
                        {formatCurrency(customer.total_spent, restaurant.currency_symbol)}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-500" data-id="element-2824">
                        {formatCurrency(customer.total_spent / Math.max(1, customer.total_orders), restaurant.currency_symbol)}
                      </td>
                      <td className="px-6 py-4 text-right font-bold text-brand-charcoal" data-id="element-2825">
                        {customer.current_points}
                      </td>
                      <td className="px-6 py-4" data-id="element-2826">
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-2827">
                          {customer.current_level || 'Inicial'}
                        </span>
                      </td>
                    </tr>)}
              </tbody>
            </table>
          </div>
        </Card>
      </div>
    </AdminLayout>;
}